import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { usePermissions } from '@practium/features/permissions';
import { AddSystemPage } from './AddSystemPage';
import type { SystemTab, SystemSubject } from '../types/system.types';

const TAB_SUBJECT: Record<SystemTab, SystemSubject> = {
	permissions: 'groups',
	hierarchies: 'hierarchies',
	plans: 'plans',
};

export const AddSystemPageAdmin = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const type = (searchParams.get('type') as SystemTab) || 'permissions';
	const { abilities, isLoading } = usePermissions();
	const canCreate = abilities.can('create', TAB_SUBJECT[type]);

	useEffect(() => {
		if (!isLoading && !canCreate) navigate(`/sistema?tab=${type}`, { replace: true });
	}, [isLoading, canCreate, navigate, type]);

	if (isLoading || !canCreate) return null;

	return (
		<AddSystemPage
			type={type}
			onBack={() => navigate(`/sistema?tab=${type}`)}
		/>
	);
};
